import React from 'react';
import Layout from '../../components/Layout';
import SeoServiceHub from './SeoServiceHub';
import NotFound from '../../components/NotFound/NotFound';
import getSeoServiceHubQuery from './getSeoServiceHub.graphql';

// Public service hub: /services/:service
async function action({ params, client, store }) {
  const siteTitle =
    (store.getState().siteSettings && store.getState().siteSettings.data && store.getState().siteSettings.data.siteTitle) ||
    'BestHand';

  let hub = null;
  try {
    const { data } = await client.query({
      query: getSeoServiceHubQuery,
      variables: { serviceSlug: params.service },
      fetchPolicy: 'network-only',
    });
    hub = data && data.getSeoServiceHub;
  } catch (e) {
    hub = null;
  }

  if (!hub || hub.status !== 200) {
    return {
      title: `Page Not Found | ${siteTitle}`,
      component: (<Layout><NotFound title={'Page Not Found'} /></Layout>),
    };
  }

  return {
    title: `${hub.serviceName} near you | ${siteTitle}`,
    // COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod.
    description: `Find trusted, background-checked ${hub.serviceName.toLowerCase()} pros near you. Upfront pricing, fast scheduling, satisfaction guaranteed.`,
    component: (<Layout><SeoServiceHub hub={hub} /></Layout>),
  };
}

export default action;
